/* CloudBolt framework for standard behavior for drag & drop sorting of items
 */

(function (c2, $, _) {
  'use strict';

  /* Convenience function applies the HTML5 sortable plugin to a set of
   * elements and provides a framework for consistent look & feel and behavior.
   *
   * Each sortable element should have a data-id attribute containing the
   * server-side ID of the item it represents.
   *
   * Args:
   *
   * - sortableGroupSelector: selects one or more elements that contain a set
   *   of elements to be made sortable.  Sortable dragging and dropping is
   *   constrained within their group container.
   *
   * - updateURL: URL to a view that will handle the POST request on drop. It
   *   will receive a list of item IDs in the new order, in a variable named
   *   'seq'.
   *
   * - dropCallback: a function called after a drop action has been handled.
   *   One arg is passed to it: the jQuery object for the updated group
   *   container. We use this callback, for example, to collapse sequence
   *   numbers for items that will run in parallel.  Note, the sequence numbers
   *   will have been saved server-side before this handler is called.
   */
  function sortablePanels(sortableGroupSelector, updateURL, dropCallback) {
    $(sortableGroupSelector)
      .each(initializeSortGroup)
      .sortable({
        handle: '.sortable-handle', // only the handle allows drag initiation
        forcePlaceholderSize: true
      })

      .bind('sortupdate', function (e, ui) {
        var $group = ui.item.closest(sortableGroupSelector);
        var newSequenceOfIDs = resequenceSortables($group);

        $.post(
          updateURL,
          {seq: newSequenceOfIDs},
          function (response) {
            // Don't show the success message, at least for now. There are too
            // many places where we return success: true and a message of "true"
            // looks bad.
            // if (response.success) {
            //   c2.alerts.addGlobalAlert(response.success, 'success', true, 5000);
            // }
            if (response.error) {
              c2.alerts.addGlobalAlert(response.error, 'error', true, 5000);
            }
          }
        );

        if (dropCallback !== undefined) {
          dropCallback($group);
        }
      });
  }


  // Add some markup needed for layout of sort handles
  function initializeSortGroup() {
    var $this = $(this);
    var $cards = $this.find('.card');

    // Only add sortable options if there is more than one card
    if($cards.length <= 1) {
      return;
    }

    $cards
      .addClass('sortable') // simplifies styling of handles
      .find('.card-header').each(function(index) {
        // Add a sequence number in each handle element.  This
        // clarifies that the order of items is significant.
        $(this).prepend(
          '<span class="move-to-top-or-bottom">' +
            '  <i class="bi bi-chevron-double-up"></i>' +
            '  <i class="bi bi-chevron-double-down"></i>' +
          '</span>' +
          '<span class="sortable-handle">' +
          '  <i class="bi bi-grip-vertical"></i>' +
          '</span>' +
          '<span class="sort-seq">'+ (index + 1) + '</span>'
        );
      });
    // Move to top or bottom of list
    $this.find('.move-to-top-or-bottom .bi-chevron-double-up, .move-to-top-or-bottom .bi-chevron-double-down').on('click', function () {
      var $el = $(this);
      var moveToTop = $el.hasClass('bi-chevron-double-up');
      var $item = $el.closest('li');
      var $parentContainer = $item.parent();
      var $newLocation = moveToTop ? $parentContainer.children('li:first-child') : $parentContainer.children('li:last-child');
      moveAnimate($item, $newLocation);
      $parentContainer.triggerHandler('sortupdate', {item: $item});
    });
    // The number for the element to specify a new location as a number input
    $this.find('.sort-seq').on('click', function () {
      var $el = $(this);
      var $item = $el.closest('li');
      var $parentContainer = $item.parent();

      // Cache original value
      var initialValue = $el.text();

      // Hide original value
      $el.text('');

      // Adds the input to the DOM to specify new sequence location
      $el.append('<input type="number" class="sort-seq-input" />');

      var $sortSeqInput = $('.sort-seq-input');
      $sortSeqInput.focus();

      $sortSeqInput.on('click', function(e) {
        // We don't want click events to cause side effects like adding additional inputs
        e.stopPropagation();
      })

      // Execute change for enter and remove input element for enter or escape
      $sortSeqInput.on('keydown', function(e) {
        var $elInput = $(this);
        if(e.key === "Enter") {
          var index = $elInput.val();
          $elInput.off();
          $elInput.remove();
          if (index) {
            var $newLocation;
            if (index < 1) {
              $newLocation = $parentContainer.children('li:first-child');
            } else if (index >= $parentContainer.children('li').length) {
              $newLocation = $parentContainer.children('li:last-child');
            } else {
              $newLocation = $parentContainer.children('li:nth-child(' + index + ')');
            }
            moveAnimate($item, $newLocation);
            $parentContainer.triggerHandler('sortupdate', {item: $item});
          } else {
            $el.text(initialValue);
          }
          $elInput.remove();
        }
        if(e.key === "Escape") {
          $elInput.off();
          $elInput.remove();
          $el.text(initialValue);
        }
      })

      // Clicking on another location or tabbing out of it removes the input element
      $sortSeqInput.on('blur', function() {
        var $elInput = $(this);
        $elInput.off();
        $elInput.remove();
        $el.text(initialValue);
      })
    });
  }

  function moveAnimate(element, newLocation){
    //Allow passing in either a jQuery object or selector
    var $element = $(element);
    var $newLocation = $(newLocation);
    var useCompact = $element.parent().hasClass('compact-sortables');

    var oldOffset = $element.offset();
    // Move the element to its new location
    $newLocation.index() < $element.index() ? $element.insertBefore($newLocation) : $element.insertAfter($newLocation);
    var newOffset = $element.offset();

    var temp = $element.clone().appendTo('body');
    // Set initial values for animation purposes
    temp.css({
        'position': 'absolute',
        'left': oldOffset.left,
        'top': oldOffset.top,
        'list-style-type': 'none',
        'z-index': 1000,
        'width': $element.width()
    });
    if (!temp.hasClass('compact-sortables') && useCompact) {
      temp.addClass('compact-sortables')
    }
    // Visibility allows the space on the screen to remain where .hide() would not
    $element.css('visibility', 'hidden');
    // Animates the element moving from the old location to the new one
    temp.animate({'top': newOffset.top, 'left': newOffset.left}, 'slow', function(){
       //Once animation completes, clean up css and temp element
       $element.css('visibility', 'visible');
       temp.remove();
    });
}


  /* Apply drag-to-reorder behavior to a plain table's rows, matching the
   * pattern used on the Orchestration Actions page: a `.drag-handle` cell
   * with a grip icon in each row, POSTing the new row order to updateURL
   * on drop.
   *
   * Args:
   *
   * - tbodySelector: selects the <tbody> containing the rows to make
   *   sortable.
   *
   * - updateURL: URL to a view that will handle the POST request on drop. It
   *   will receive a list of item IDs in the new order, in a variable named
   *   'seq'.
   *
   * Each row's drag handle should carry a `data-drag-id` attribute with the
   * server-side ID of the item it represents.
   *
   * Rows may also include `.move-row-top` / `.move-row-bottom` controls
   * (e.g. chevron icons) to jump a row directly to the top or bottom of the
   * table without dragging.
   */
  function sortableRows(tbodySelector, updateURL) {
    var $tbody = $(tbodySelector);

    function postNewOrder() {
      var ids = $tbody
        .find('tr .drag-handle')
        .map(function () { return $(this).data('drag-id'); })
        .get();
      if (ids.length) {
        $.post(updateURL, {seq: ids}).fail(function () {
          c2.alerts.addGlobalAlert('Could not save the new order.', 'error', true, 5000);
        });
      }
    }

    $tbody.sortable({
      handle: '.drag-handle',
      items: '> tr',
      axis: 'y',
      containment: 'parent',
      tolerance: 'pointer',
      helper: function (e, ui) {
        // Lock cell widths so the dragged row keeps its layout.
        ui.children().each(function () { $(this).width($(this).width()); });
        return ui;
      },
      update: postNewOrder
    });

    $tbody.on('click', '.move-row-top, .move-row-bottom', function () {
      var $row = $(this).closest('tr');
      if ($(this).hasClass('move-row-top')) {
        $tbody.prepend($row);
      } else {
        $tbody.append($row);
      }
      postNewOrder();
    });
  }


  // Renumber all sortables client side and return a list of IDs in the new
  // order.
  function resequenceSortables($group) {
    var $handles = $group.find('.sortable-handle').toArray();
    return _.map($handles, function (item, index) {
      var $handle = $(item);
      // ID is stored on the card containing the drag handle
      var cardID = $handle.closest('.card').data('id');
      if (cardID) {
        // Assign it a new user-visible sequence number
        $handle.siblings('.sort-seq').text(index + 1);
      } else {
        // Ignore placeholder
      }

      return cardID;
    });
  }


  c2.sortable = {
    resequenceSortables: resequenceSortables,
    sortablePanels: sortablePanels,
    sortableRows: sortableRows
  };

})(window.c2, window.jQuery, window._);
